import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const VisaRequestDetails = ({ visaResources }) => {
    return (
        <>
            {
                visaResources.map((resource, index) =>
                    <Paper key={index} className="detail-wrapper">
                        <Typography variant="button" display="block" gutterBottom>
                            {resource.visaCountryName}
                        </Typography>
                        <Typography variant="subtitle2" display="block" gutterBottom>
                            {resource.noVisas} Visas, [{resource.visaFromDate.substring(0, 10)} To {resource.visaToDate.substring(0, 10)}]
                                </Typography>
                    </Paper>
                )
            }
        </>
    )
}

export default VisaRequestDetails;